import styled from "@emotion/styled";
import { Modal, modalClasses } from "@kaltura/ds-react-components";

export const StyledCreateTownhallModal = styled(Modal)(({ theme }) => ({
    [`& .${modalClasses.paper}`]: {
        minWidth: 664,
        maxWidth: 664,
        height: "70vh",
        [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
            minWidth: "100%",
            maxWidth: "100%",
            height: "100%",
        },
    },
}));
